import { createSelector } from '@reduxjs/toolkit';
import { enhancedApi } from './codegen';

export const {
    initiate: initiateTechnologiesList,
    matchFulfilled: matchFulfilledTechnologiesList,
    matchPending: matchPendingTechnologiesList,
    matchRejected: matchRejectedTechnologiesList,
} = enhancedApi.endpoints.widgetTechnologiesList;

export const selectTechnologiesResult = enhancedApi.endpoints.widgetTechnologiesList.select({});
